<template>
    <div class="table_wrap">
      <div class="c_table_wrap table_search_wrap">
        사용내역 디폴트 필터
      </div>
    </div>
</template>

<script>
export default {
  name: "HistoryFilterDefaultLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>